export const trackingRewardStreamsAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "evc",
        type: "address",
        internalType: "address",
      },
      {
        name: "epochDuration",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "EPOCH_DURATION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "EVC",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MAX_DISTRIBUTION_LENGTH",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MAX_EPOCHS_AHEAD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MAX_REWARDS_ENABLED",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "balanceOf",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "balanceTrackerHook",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "newAccountBalance",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "forfeitRecentReward",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "claimReward",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
      {
        name: "recipient",
        type: "address",
        internalType: "address",
      },
      {
        name: "ignoreRecentReward",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "currentEpoch",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "disableReward",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
      {
        name: "forfeitRecentReward",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "earnedReward",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
      {
        name: "ignoreRecentReward",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "enableReward",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "enabledRewards",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getEpoch",
    inputs: [
      {
        name: "timestamp",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getEpochEndTimestamp",
    inputs: [
      {
        name: "epoch",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getEpochStartTimestamp",
    inputs: [
      {
        name: "epoch",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isRewardEnabled",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "registerReward",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
      {
        name: "startEpoch",
        type: "uint48",
        internalType: "uint48",
      },
      {
        name: "rewardAmounts",
        type: "uint128[]",
        internalType: "uint128[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "rewardAmount",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "rewardAmount",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
      {
        name: "epoch",
        type: "uint48",
        internalType: "uint48",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "totalRewardClaimed",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "totalRewardRegistered",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "totalRewardedEligible",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "updateReward",
    inputs: [
      {
        name: "rewarded",
        type: "address",
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        internalType: "address",
      },
      {
        name: "recipient",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "BalanceUpdated",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "oldBalance",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "newBalance",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RewardClaimed",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RewardDisabled",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RewardEnabled",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RewardRegistered",
    inputs: [
      {
        name: "caller",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "rewarded",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "reward",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "startEpoch",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "amounts",
        type: "uint128[]",
        indexed: false,
        internalType: "uint128[]",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "AccumulatorOverflow",
    inputs: [],
  },
  {
    type: "error",
    name: "ControllerDisabled",
    inputs: [],
  },
  {
    type: "error",
    name: "EVC_InvalidAddress",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidAmount",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidDistribution",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidEpoch",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidRecipient",
    inputs: [],
  },
  {
    type: "error",
    name: "NotAuthorized",
    inputs: [],
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: [],
  },
  {
    type: "error",
    name: "SafeERC20FailedOperation",
    inputs: [
      {
        name: "token",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "TooManyElements",
    inputs: [],
  },
  {
    type: "error",
    name: "TooManyRewardsEnabled",
    inputs: [],
  },
] as const
